$.fn.ThumbnailsGallery = function() {
  let self = this
  self.thumbnails = self.find('a.thumbnails__item')
  self.container = self.find('.thumbnails-gallery-container')
  self.initial_picture = self.find('.thumbnails-gallery-container picture')
  self.current_picture = self.find('.thumbnails-gallery-container picture')

  self.resized = function() {
    let pictureHeight = $('.thumbnails-gallery-container .thumbnail-picture').outerHeight(false)
    $('.thumbnails-gallery-container').css({
      height: pictureHeight + 'px',
    })
  }

  self.clicked = function(e) {
    e.preventDefault()
    let pictureID = parseInt($(this).data('picture'), 10)
    let picture = $('.thumbnail-picture-' + pictureID)
    self.container.append(picture)
    picture.css('display', 'block')
    let pictureHeight = picture.outerHeight(false)
    picture.hide()
    self.current_picture.fadeOut(350, function() {
      if ($(this).is(self.initial_picture)) {
        $(this).remove()
      }
    })
    $('.thumbnails-gallery-container').animate({
      height: pictureHeight + 'px',
    }, 350, 'swing', function() {
      self.current_picture = picture
      picture.fadeIn(250)
    })
  }

  return function() {
    self.thumbnails.on('click', self.clicked)
    $(window).on('load resize orientationchange', self.resized)
    return self
  }()
}
